<template lang="pug">
.qmodii-modal-content
  VCard
    VCardTitle 
      span.headline {{ $t('screener.presetscreener') }}
      VSpacer
      VBtn(icon, @click="close()"): i.material-icons.md-18 close
    VCardText
      VExpansionPanel(focusable)
        VExpansionPanelContent(v-for="item in options", :key="item.id")
          template(slot="header")
            div {{ item.name }}
          VCard
            VCardText
              .qmod-accord-text {{ item.description }}
              VSpacer
              VBtn(color="primary", block, @click="setScreen(item)") {{ $t('labels.select') }}
</template>

<script>
import {
  VDialog,
  VTab,
  VTabs,
  VTabsItems,
  VTabItem,
  VExpansionPanel,
  VExpansionPanelContent,
  VList,
  VSubheader,
  VListTile,
  VListTileContent,
  VListTileTitle,
  VListTileSubTitle,
  VListTileAction,
  VLayout,
  VFlex,
  VTextField,
  VSelect,
  VIcon,
  VBtn,
  VSpacer,
  VCard,
  VCardTitle,
  VCardText,
  VCardActions,
} from "vuetify/lib";
import ToggleButton from "@LAYOUT/ToggleButton";

export default {
  name: "indicatorModal",
  components: {
    VDialog,
    VTabsItems,
    VTabItem,
    VTab,
    VTabs,
    VExpansionPanel,
    VExpansionPanelContent,
    VList,
    VSubheader,
    VListTile,
    VListTileContent,
    VListTileTitle,
    VListTileSubTitle,
    VListTileAction,
    VLayout,
    VFlex,
    VTextField,
    VSelect,
    VIcon,
    ToggleButton,
    VBtn,
    VSpacer,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
  },
  mounted() {
    this.$watch(
      "$i18n.locale",
      async (newLocale, oldLocale) => {
        if (newLocale === oldLocale) {
          return;
        }
        await this.getScreens();
        //
      },
      { immediate: false }
    );
  },
  props: [],
  data() {
    return {
      options: [],
    };
  },
  methods: {
    async getScreens() {
      try {
        const criteriaResults = await this.$qModCore.axios.get(
          `//${this.$store.state.ENV}.quotemedia.com/screener/preset/datatool/type/equity?webmaster_id=${this.$store.state.WMID}&token=${this.$store.state.MarketScreener.componentToken}&language=${this.$i18n.locale}`
        );
        this.options = criteriaResults.data.presetScreenList;
      } catch (e) {
        return "INVALID";
      }
    },
    close() {
      this.$emit("finished");
    },
    async setScreen(screen) {
      let screens = JSON.parse(screen.filters);
      await this.$store.dispatch(
        "MarketScreener/setEquityFromScreens",
        screens
      );
      this.close();
    },
  },
  computed: {
    getEnabled() {
      return this.isEnabled ? "On" : "Off";
    },
  },
  async created() {
    await this.getScreens();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.qmod-accord-text
  margin-bottom 25px
.qmodii-modal-content
  width 100%
</style>
